<div
  #trigger
  class="operation-popover-trigger"
  (mouseleave)="onMouseLeave($event, popover)"
  (mouseover)="onMouseHover()"
>
  <ng-content select="[slot='trigger']"></ng-content>
</div>

<fw-popover #popover action="mouseenter" position="above" [trigger]="trigger">
  <div class="operation-popover">
    <div class="operation-popover-list">
      @for (key of config(); track key) {
        @if (data()[key]) {
          <div class="operation-popover-list-item">
            <span class="operation-popover-list-item-key">{{ getFieldLabel(key) }}</span>
            <fw-tooltip class="operation-popover-list-item-tooltip" [title]="isTooltip(key) ? data()[key] : ''">
              @if (key !== OperationPopoverFields.JobSchedule) {
                <span class="operation-popover-list-item-value" [ngStyle]="{ maxWidth: maxWidth() }">{{
                  dateFields.includes(key) ? (data()[key] | date: dateMask) : data()[key]
                }}</span>
              } @else {
                <span class="operation-popover-list-item-value" [ngStyle]="{ maxWidth: maxWidth() }">
                  {{ humanReadableCron() }} ({{ data()[key] }})</span
                >
              }
            </fw-tooltip>
          </div>
        }
      }
    </div>
    <ng-content select="[slot='footer']"></ng-content>
  </div>
</fw-popover>
